import React from "react";

interface TypingIndicatorProps {
  size?: number;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  size = 0.9,
}) => {
  const width = 120 * size;
  const height = 80 * size;
  const jump = 12 * size;
  const dur = 1.1;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 80"
      width={width}
      height={height}
    >
      <rect
        x={10 * size}
        y={10 * size}
        width={100 * size}
        height={50 * size}
        rx={25 * size}
        ry={25 * size}
        className="fill-accent"
      />

      {[0, 1, 2].map((i) => (
        <circle
          key={i}
          cx={(45 + i * 15) * size}
          cy={35 * size}
          r={5 * size}
          className="fill-muted-foreground animate-pulse"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            values={`0,0; 0,${-jump}; 0,0`}
            keyTimes="0; 0.5; 1"
            dur={`${dur}s`}
            repeatCount="indefinite"
            begin={`${i * 0.2}s`}
          />
        </circle>
      ))}
    </svg>
  );
};
export default TypingIndicator;
